import { RouteObject } from 'react-router-dom';
import { appPaths } from 'consts/paths/paths';
import {
    GroupJournalConsultationAddPage,
    GroupJournalConsultationDetailsPage,
    GroupJournalConsultationEditPage,
} from 'pages';
import { AppActions } from 'types';
import { PERMISSIONS_NAME } from 'consts/permissions/permissions';
import { AbilityRoute } from 'navigation/AbilityRoute/AbilityRoute';
import { JournalNavigate } from 'navigation/routes/loggedApp/routes/staff/journal/components';

export const journalConsultationRoutes: RouteObject[] = [
    {
        path: appPaths.app.journals.groupJournalDetails.pickedJournal.consultations.add,
        element: (
            <AbilityRoute
                can={{
                    action: AppActions.EDIT_AND_ADD,
                    subject: PERMISSIONS_NAME.GROUP_JOURNALS_CONSULTATIONS,
                }}
            >
                <GroupJournalConsultationAddPage />
            </AbilityRoute>
        ),
    },
    {
        path: appPaths.app.journals.groupJournalDetails.pickedJournal.consultations.edit.base,
        element: (
            <JournalNavigate
                to={appPaths.app.journals.groupJournalDetails.pickedJournal.consultations.base}
            />
        ),
    },
    {
        path: appPaths.app.journals.groupJournalDetails.pickedJournal.consultations.edit
            .pickedConsultation,
        element: (
            <AbilityRoute
                can={{
                    action: AppActions.EDIT_AND_ADD,
                    subject: PERMISSIONS_NAME.GROUP_JOURNALS_CONSULTATIONS,
                }}
            >
                <GroupJournalConsultationEditPage />
            </AbilityRoute>
        ),
    },
    {
        path: appPaths.app.journals.groupJournalDetails.pickedJournal.consultations.details.base,
        element: (
            <JournalNavigate
                to={appPaths.app.journals.groupJournalDetails.pickedJournal.consultations.base}
            />
        ),
    },
    {
        path: appPaths.app.journals.groupJournalDetails.pickedJournal.consultations.details
            .pickedConsultation,
        element: (
            <AbilityRoute
                can={{
                    action: AppActions.VIEW,
                    subject: PERMISSIONS_NAME.GROUP_JOURNALS_CONSULTATIONS,
                }}
            >
                <GroupJournalConsultationDetailsPage />
            </AbilityRoute>
        ),
    },
];
